// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p2OX","label":"styles_label__4s_mC"};